import axiosInstance from "../../../api/axiosConfig";
import { RegisterFormValues } from "./register-page.type";

export const register = (data: RegisterFormValues) => {
  return axiosInstance.post("/auth/register", data);
};
